<template>
  <div class="home container-div">
    <div class="title-container">
      <p class="presented-by">MANNY GUMINA PRESENTS</p>
      <h1 class="title">CREATURE<br>FEAR</h1>
      <p class="description">AN UNHINGED WISCONSIN HORROR FILM</p>
    </div>

    <img class="hero-img" src="../assets/hero-img.png" alt="hero img">
    <p class="description mobile">An unhinged Wisconsin horror film</p>
  </div>

  <!-- LAURELS -->
    <div class="laurels">
      <img src="../assets/laurel_1.png" alt="laurel 1">
      <img src="../assets/laurel_2.png" alt="laurel 2">
      <img src="../assets/laurel_3.png" alt="laurel 3">
      <img src="../assets/laurel_4.png" alt="laurel 4">
      <img src="../assets/laurel_5.png" alt="laurel 5">
      <img src="../assets/laurel_6.png" alt="laurel 6">
    </div>

  <div class="credit">
    <!-- unchanged -->
    <p class="credit-small">PRODUCED BY</p>
    <p class="credit-large">&nbsp;MANNY GUMINA &amp; DEREK SCHMITT&nbsp;</p>
    <p class="credit-small">IN ASSOCIATION WITH</p>
    <p class="credit-large">&nbsp;KERNEL PRODUCTIONS&nbsp;</p>
    <br>
    <p class="credit-small">STARRING</p>
    <p class="credit-large">&nbsp;NATALIE GERENE JARROD LANGWINSKI &AMP; BILLY CHENGARY&nbsp;</p>
    <p class="credit-small">WITH</p>
    <p class="credit-large">&nbsp;JIMMY ROMANO &AMP; DAVID PRECOUR&nbsp;</p>
    <br>
    <p class="credit-small">ORIGINAL MUSIC BY</p>
    <p class="credit-large">&nbsp;ANTONIO ROMERO&nbsp;</p>
    <p class="credit-small">SOUND DESIGN BY</p>
    <p class="credit-large">&nbsp;JAKE HELMEN&nbsp;</p>
    <p class="credit-small">EDITED BY</p>
    <p class="credit-large">&nbsp;CHRIS DAVIES&nbsp;</p>
    <br>
    <p class="credit-small">CINEMATOGRAPHY BY</p>
    <p class="credit-large">&nbsp;DEREK SCHMITT&nbsp;</p>
    <p class="credit-small">PRODUCTION DESIGN BY</p>
    <p class="credit-large">&nbsp;HANNAH DARLENE&nbsp;</p>
    <p class="credit-small">WRITTEN &AMP; DIRECTED BY</p>
    <p class="credit-large">&nbsp;MANNY GUMINA&nbsp;</p>
  </div>
</template>

<script>
</script>

<style>
.laurels {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin: 48px 0;
}

.laurels img {
  max-width: 150px;
  width: 100%;
  height: auto;
}

@media (max-width: 600px) {
  .laurels {
    gap: 10px;
  }
}
</style>
